<form [formGroup]="radioForm" class="radio-input-container" [attr.data-test]="'neqto-' + field.key">
  @if (props.options | observablePipe | async; as options) {
    @for (option of options; track option) {
      <div class="p-field-radiobutton">
        <p-radioButton [value]="option.value" formControlName="radio" [inputId]="option.value" name="radio" />

        <label [for]="option.value" [class.has-tooltip]="option.tooltip">
          <span class="label">{{ option.label }}</span>

          @if (option.tooltip) {
            <i class="mynaui-info-circle info" [pTooltip]="tooltipContent" tooltipStyleClass="neqto-tooltip info"></i>
            <ng-template #tooltipContent>
              <div class="tooltip-content">
                <p>{{ option.tooltip }}</p>
              </div>
            </ng-template>
          }
        </label>
      </div>
    }
  }
</form>
